import Vue from 'vue';
import { Howl } from 'howler';

const AudioBus = new Vue({
  name: 'AudioBus',
  data() {
    return {
      currentlyPlaying: '' as string,
      playing: false as boolean,
    };
  },
  methods: {
    stop: function stop() {
      this.currentlyPlaying = '';
      this.playing = false;
    },
    play: function play(name: string) {
      this.currentlyPlaying = name;
      this.playing = true;

      this.$emit('play', [name]);
      this.$emit(`play-${name}`, [name]);
    },
  },
});

interface PlaylistInterface {
  audio: {
    [name: string]: {
      name: string;
      sourceList: string | string[];
      options: {};
      howl: Howl;
    };
  };
  addAudio?: CallableFunction;
  play?: CallableFunction;
  pause?: CallableFunction;
  stop?: CallableFunction;
}

const Playlist: PlaylistInterface = {
  audio: {},
};
Playlist.addAudio = (name: string, sourceList: string | string[], options = {}): Howl => {
  if (Playlist.audio[name]) {
    return Playlist.audio[name].howl;
  }

  const audio = new Howl({
    src: sourceList,
    html5: true,
    onplay: () => {
      AudioBus.play(name);
    },
    onpause: () => {
      AudioBus.stop();

      AudioBus.$emit(`pause-${name}`, [name]);
      AudioBus.$emit('pause', [name]);
    },
    onend: () => {
      AudioBus.stop();

      AudioBus.$emit('end', [name]);
      AudioBus.$emit(`end-${name}`, [name]);
    },
    ...options,
  });

  Playlist.audio[name] = {
    name,
    sourceList,
    options,
    howl: audio,
  };

  return audio;
};

Playlist.play = (name: string) => {
  if (!Playlist.audio[name]) {
    throw new Error(`Audio [${name}] is not loaded.`);
  }

  // Check if audio is currently playing already.
  if (AudioBus.playing && AudioBus.currentlyPlaying === name) {
    return;
  }

  // Stop if there is audio playing
  if (AudioBus.playing) {
    Playlist.audio[AudioBus.currentlyPlaying].howl.pause();
  }

  // Now play
  Playlist.audio[name].howl.play();
};

Playlist.pause = (name?: string) => {
  if (!AudioBus.playing) {
    return;
  }

  const audio = name ?? AudioBus.currentlyPlaying;
  if (!Playlist.audio[audio]) {
    throw new Error(`Audio [${audio}] is not loaded.`);
  }

  Playlist.audio[audio].howl.pause();
};

Playlist.stop = Playlist.pause;

export default {
  AudioBus,
  Playlist,
};
